import { createSelector, createFeatureSelector } from '@ngrx/store';
import { NewsState } from './news.reducer';
import { AppState } from '../app.state';

// Feature selector for the ProductState
export const selectProductState = createFeatureSelector<AppState, NewsState>('news');


// Selector for news products
export const selectNews = createSelector(
  selectProductState,
  (state: NewsState) => state.news
);

// Selector for loading state
export const selectNewsLoading = createSelector(
  selectProductState,
  (state: NewsState) => state.loading
);

// Selector for error state
export const selectNewsError = createSelector(
  selectProductState,
  (state: NewsState) => state.error
);
